import { render, staticRenderFns } from "./SubcategoryList.vue?vue&type=template&id=7145452e&scoped=true"
import script from "./SubcategoryList.vue?vue&type=script&lang=js"
export * from "./SubcategoryList.vue?vue&type=script&lang=js"
import style0 from "./SubcategoryList.vue?vue&type=style&index=0&id=7145452e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7145452e",
  null
  
)

export default component.exports